(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["popular-in-cart-badge"] && !Shopify.designMode) return;
  try {
    const initializePopularInCartBadges = () => {
    const badges = document.querySelectorAll('[data-popular-in-cart-badge]');
    const storagePrefix = 'popular-in-cart-badge:';
    const storageDuration = 10 * 60 * 1000;

    if (!badges.length) return;

    const getFallbackCount = (productId) => {
      const numericProductId = Number(productId);
      return Number.isFinite(numericProductId) ? (numericProductId % 5) + 1 : 1;
    };

    const getCount = (productId) => {
      const fallbackCount = getFallbackCount(productId);

      try {
        const storageKey = `${storagePrefix}${productId}`;
        const storedValue = window.localStorage.getItem(storageKey);
        const stored = storedValue ? JSON.parse(storedValue) : null;
        const storedCount = stored ? Number(stored.count) : NaN;
        const storedAt = stored ? Number(stored.timestamp) : NaN;

        if (
          Number.isInteger(storedCount) &&
          storedCount >= 1 &&
          storedCount <= 5 &&
          Number.isFinite(storedAt) &&
          Date.now() - storedAt < storageDuration
        ) {
          return storedCount;
        }

        const newCount = Math.floor(Math.random() * 5) + 1;
        window.localStorage.setItem(
          storageKey,
          JSON.stringify({ count: newCount, timestamp: Date.now() })
        );
        return newCount;
      } catch (error) {
        return fallbackCount;
      }
    };

    badges.forEach((badge) => {
      const productId = badge.dataset.productId;
      const countElement = badge.querySelector('[data-popular-in-cart-count]');

      if (!productId || !countElement) return;

      countElement.textContent = String(getCount(productId));
      badge.style.visibility = 'visible';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePopularInCartBadges, { once: true });
  } else {
    initializePopularInCartBadges();
  }
  } catch(e) { console.error(e); }
})();

})();
